import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type {
  Cause_Bool_Exp,
  GetCauseCountQuery,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetCauseCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

type CauseCountArgs = NavigationCountArgs & {
  // The equivalent Hasura bool_exp — drives the GraphQL fallback so the
  // flag-gated twin counts identically. Built by useEntityWhereFilter.
  where?: Cause_Bool_Exp;
};

export const useGetCauseCount = createQueryHook<
  CauseCountArgs,
  NavigationCounts,
  GetCauseCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    cause_aggregate: { aggregate: toAggregate(data.cause) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetCauseCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
